import React from 'react';

import {
    SItemsContainer
} from './styles';

import { H2 } from '../../atoms/Typography';
import Section from '../../layout/Section';
import OrderedItem from './OrderedItem';
import SquareGenerator from '../../molecules/SquareGenerator';

const SectionOrderedItems = ({
    config,
    titleUnderline = false,
    background = '',
}) => {
    const {
        title,
        id,
        itemList,
        squares,
        forwardedRef,
    } = config;

    return (
        <Section
            background={ background }
            forwardedRef={ forwardedRef }
            id={ id }
        >
            <H2 titleUnderline={ titleUnderline }>
                { title }
            </H2>
            <SItemsContainer>
                {
                    itemList.map( item => (
                        <OrderedItem
                            key={ item.id }
                            itemData={ item }
                        />
                    ))
                }
            </SItemsContainer>
            {
                !!squares && <SquareGenerator squares={ squares }/>
            }
        </Section>
    );
};

export default SectionOrderedItems;
